import React from "react";
import "./HomeCard.css";
const HomeCard = (props) => {
  const { jamat, student, Age, addmisionFee, monthlyFee, img } =
    props.homeCourse || {};

  return (
    <div className="col">
      <div className="card p-2 m-3">
        <img src={img} height="250px" className="card-img-top" alt={jamat} />
        <div className="card-body">
          <h5 className="card-title">Class Name: {jamat}</h5>
          <p className="card-text">Total Student: {student}</p>
          <p className="card-text">Age: {Age}</p>
          <p className="card-text">AddmisionFee: {addmisionFee}</p>
          <p className="card-text">Monthly Fee: {monthlyFee}</p>
          <button type="button" className="btn btn-success">
            Addmision Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeCard;
